import { Outlet, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Zap, FileText, ShoppingBag, CreditCard, Users,
} from "lucide-react";
import { useScenario } from "../../store";
import { COMPANIES } from "../../mocks/seed";
import { LegacyAppShell } from "./LegacyAppShell";

const RAIL_ITEMS = [
  { id: "dashboard", icon: LayoutDashboard, label: "Dashboard", path: "/b2b" },
  { id: "quick", icon: Zap, label: "Quick", path: "/b2b/quick-order" },
  { id: "requisitions", icon: FileText, label: "Req.", path: "/b2b/requisitions" },
  { id: "quotes", icon: ShoppingBag, label: "Quotes", path: "/b2b/quotes" },
  { id: "pos", icon: ShoppingBag, label: "POs", path: "/b2b/purchase-orders" },
  { id: "credit", icon: CreditCard, label: "Credit", path: "/b2b/credit" },
  { id: "users", icon: Users, label: "Users", path: "/b2b/users" },
];

const TABS: Record<string, { label: string; path: string; end?: boolean }[]> = {
  dashboard: [{ label: "B2B Dashboard", path: "/b2b", end: true }],
  quick: [{ label: "Quick Order", path: "/b2b/quick-order" }],
  requisitions: [{ label: "Requisitions", path: "/b2b/requisitions" }],
  quotes: [{ label: "Quotes / RFQ", path: "/b2b/quotes" }],
  pos: [{ label: "Purchase Orders", path: "/b2b/purchase-orders" }],
  credit: [{ label: "Credit & Ledger", path: "/b2b/credit" }],
  users: [{ label: "Users & Roles", path: "/b2b/users" }],
};

function getActiveSection(pathname: string) {
  if (pathname === "/b2b" || pathname === "/b2b/") return "dashboard";
  if (pathname.startsWith("/b2b/quick")) return "quick";
  if (pathname.startsWith("/b2b/req")) return "requisitions";
  if (pathname.startsWith("/b2b/quot")) return "quotes";
  if (pathname.startsWith("/b2b/purch")) return "pos";
  if (pathname.startsWith("/b2b/credit")) return "credit";
  if (pathname.startsWith("/b2b/user")) return "users";
  return "dashboard";
}

export function B2BLayout() {
  const location = useLocation();
  const scenario = useScenario();
  const activeSection = getActiveSection(location.pathname);
  const company = COMPANIES.find((c) => c.id === scenario.companyId) ?? COMPANIES[0];

  return (
    <LegacyAppShell
      brand="B2B"
      surface="B2B"
      homePath="/b2b"
      items={RAIL_ITEMS}
      activeId={activeSection}
      tabs={TABS[activeSection]}
      identity={{ name: scenario.userName, subtitle: company?.name }}
    >
      <Outlet />
    </LegacyAppShell>
  );
}
